import React from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import PublicLayout from '../../../layouts/public';
import { lzGetAssetUrl, lzShowSuccessMessage } from '../../../../services/LzUtils';
import ImgLogo from '../../../../assets/images/logo.png';
import ImgLzLogo from '../../../../assets/images/lz-logo.png';
import { Link } from 'react-router-dom';
import { lzCallApi } from '../../../../services/LzApiService';

class ConfirmEmailScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      model: {
        email: props.match?.params?.email || '',
        code: props.match?.params?.code || '',
      },
    };
  }

  componentDidMount() {
    if (this.state.model.email !== '' && this.state.model.code !== '') {
      this.callConfirmApi();
    }
  }

  handleInputChange = (name, value) => {
    this.setState({ [name]: value });
  };

  onSubmit(evt) {
    evt.preventDefault();
    this.callConfirmApi();
  }

  async callConfirmApi() {
    const { history } = this.props;
    const { model } = this.state;

    // Make the api call and get processed data
    const data = await lzCallApi('confirm-email', model, 'post');

    // Validate data and redirect
    if (data) {
      history.push('/user/login');
      lzShowSuccessMessage(data);
    }
  }

  async callResendApi() {
    const { model } = this.state;

    // Make the api call and get processed data
    const data = await lzCallApi('resend-confirm-email', model, 'post');

    // Validate data and redirect
    if (data) {
      lzShowSuccessMessage('Please check your email for confirmation code!');
    }
  }

  render() {
    const { model } = this.state;

    return (
      <PublicLayout>
        <div className="full-page-form">
          <Card className="card">
            <div className="half-form bg-signin">
              <form noValidate autoComplete="off" onSubmit={(evt) => this.onSubmit(evt)}>
                <img src={lzGetAssetUrl(ImgLogo)} alt="Logo" className="logo" />

                <h2>Confirm Email Address</h2>

                <FormGroup row>
                  <TextField fullWidth variant="outlined" label="Email Address" helperText="enter your email address"
                    value={model.email} onChange={(ev) => this.setState({ model: Object.assign({}, model, { email: ev.target.value }) })}
                  />
                </FormGroup>

                <FormGroup row>
                  <TextField fullWidth variant="outlined" label="Confirmation Code" helperText="enter the confirmation code you received via email"
                    value={model.code} onChange={(ev) => this.setState({ model: Object.assign({}, model, { code: ev.target.value }) })}
                  />
                </FormGroup>

                <FormGroup row>
                  <Grid container>
                    <Grid item xs={3}>
                      <Button type="submit" variant="contained" color="primary">Submit</Button>
                    </Grid>
                    <Grid item xs={9} style={{ textAlign: 'right' }}>
                      {<Button type="button" variant="text" color="secondary" onClick={() => this.callResendApi()}>Resend Code?</Button>}
                    </Grid>
                  </Grid>
                </FormGroup>

                <FormGroup row>
                  <Grid container>
                    <Grid item xs={12} style={{ textAlign: 'right', marginTop: 12 }}>
                      <Link to={'/user/register'}>Click here to go to Sign-up page.</Link>
                    </Grid>
                  </Grid>
                </FormGroup>
              </form>
            </div>
          </Card>
          <a href="https://logic-zone.net/?ref=services.2adata" target="_blank" rel="noreferrer" className="powered-by">
            Powered by :
            <img src={lzGetAssetUrl(ImgLzLogo)} alt="Logic-Zone" />
          </a>
        </div>
      </PublicLayout>
    );
  }

}

export default ConfirmEmailScreen;
